/**
 * Сервис для работы с интеграцией Avito Job API.
 *
 * Авторизация в Avito выполняется по client_credentials с использованием
 * client_id / client_secret приложения, зарегистрированного владельцем компании
 * на https://www.avito.ru/professionals/api. Данные хранятся per-company
 * на стороне relevanter-back, секрет шифруется AES-256-GCM перед записью в БД.
 *
 * Управлять подключением могут OWNER/ADMIN своей компании или SUPER_ADMIN.
 * Остальные роли видят только статус подключения.
 */

import api from '../relevanter/services/api';

export interface AvitoStatus {
  connected: boolean;
  tokenExpiresAt: string | null;
  clientIdMasked: string | null;
  canManage: boolean;
}

export interface SaveAvitoCredentialsResponse {
  connected: true;
  tokenExpiresAt: string;
}

export interface AvitoErrorBody {
  code?: string;
  message?: string;
}

export const getAvitoStatus = async (): Promise<AvitoStatus> => {
  const res = await api.get<AvitoStatus>('/avito/status');
  return res.data;
};

export const saveAvitoCredentials = async (
  clientId: string,
  clientSecret: string
): Promise<SaveAvitoCredentialsResponse> => {
  const res = await api.post<SaveAvitoCredentialsResponse>('/avito/credentials', {
    clientId,
    clientSecret,
  });
  return res.data;
};

export const deleteAvitoCredentials = async (): Promise<{ removed: boolean }> => {
  const res = await api.delete<{ removed: boolean }>('/avito/credentials');
  return res.data;
};
